import { render, staticRenderFns } from "./APP_feedbackList.vue?vue&type=template&id=fbe6b97e&scoped=true&"
import script from "./APP_feedbackList.vue?vue&type=script&lang=js&"
export * from "./APP_feedbackList.vue?vue&type=script&lang=js&"
import style0 from "./APP_feedbackList.vue?vue&type=style&index=0&id=fbe6b97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe6b97e",
  null
  
)

export default component.exports